import './style.scss';

export function featured_job_block() {
    const block = document.querySelector('.featured_job_block');
    if (!block) return;

}
